import { SimulationRecord } from "../lib/simulationsStore";
import { CalculatorInputs } from "../types";
import SimulationsList from "./SimulationsList";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  simulations: SimulationRecord[];
  onLoad: (inputs: CalculatorInputs, id: string) => void;
  onUpdate: () => void;
}

export default function SimulationsModal({
  isOpen,
  onClose,
  simulations,
  onLoad,
  onUpdate,
}: Props) {
  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Mis simulaciones"
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(15, 23, 42, 0.4)",
        backdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "960px",
          maxHeight: "85vh",
          overflow: "auto",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar simulaciones"
          style={{
            position: "absolute",
            top: "8px",
            right: "8px",
            appearance: "none",
            background: "white",
            border: "1px solid var(--border)",
            borderRadius: "999px",
            width: "36px",
            height: "36px",
            cursor: "pointer",
            fontSize: "18px",
            lineHeight: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 6px 18px rgba(15, 23, 42, 0.08)",
          }}
        >
          ×
        </button>

        <SimulationsList
          simulations={simulations}
          onLoad={onLoad}
          onUpdate={onUpdate}
        />
      </div>
    </div>
  );
}
